(function(){
  if (window.__twPdp) return; window.__twPdp = true;
  var CAP = ['113°F: gentle warmth, the place to start.', '122°F: the everyday evening setting.', '131°F: the warmest setting, for when you want it toasty.'];
  var HL = { strap: 'tw-hl-strap', panel: 'tw-hl-panel', usb: 'tw-hl-usb', vib: 'tw-vib', red: 'tw-show-red' };
  function initMap(root){
    if (root.__tw) return; root.__tw = true;
    var stage = root.querySelector('.tw-stage'), dev = root.querySelector('.tw-dev');
    var state = { hot: 'warm', level: 0 };
    function paint(){
      root.querySelectorAll('[data-tw-hot]').forEach(function(b){ b.setAttribute('aria-pressed', b.getAttribute('data-tw-hot') === state.hot ? 'true' : 'false'); });
      root.querySelectorAll('[data-tw-pane]').forEach(function(p){ p.hidden = p.getAttribute('data-tw-pane') !== state.hot; });
      root.querySelectorAll('[data-tw-level]').forEach(function(b){ b.setAttribute('aria-pressed', Number(b.getAttribute('data-tw-level')) === state.level ? 'true' : 'false'); });
      var cap = root.querySelector('[data-tw-caption]'); if (cap) cap.textContent = CAP[state.level];
      stage.className = 'tw-stage' + (HL[state.hot] ? ' ' + HL[state.hot] : '');
      dev.classList.remove('tw-glow-1','tw-glow-2','tw-glow-3');
      if (state.hot === 'warm') dev.classList.add('tw-glow-' + (state.level + 1));
    }
    root.addEventListener('click', function(e){
      var h = e.target.closest('[data-tw-hot]'); if (h) { state.hot = h.getAttribute('data-tw-hot'); paint(); return; }
      var l = e.target.closest('[data-tw-level]'); if (l) { state.level = Number(l.getAttribute('data-tw-level')); state.hot = 'warm'; paint(); }
    });
    paint();
  }
  function initCmp(root){
    if (root.__tw) return; root.__tw = true;
    var box = root.querySelector('.tw-cmp');
    root.addEventListener('click', function(e){
      var b = e.target.closest('[data-tw-cmp]'); if (!b) return;
      var k = b.getAttribute('data-tw-cmp');
      box.setAttribute('data-show', k);
      root.querySelectorAll('[data-tw-cmp]').forEach(function(x){ x.setAttribute('aria-pressed', x === b ? 'true' : 'false'); });
    });
  }
  function syncFinish(val){
    document.querySelectorAll('[data-tw-map] .tw-dev').forEach(function(d){ d.classList.toggle('tw-dev--white', /white/i.test(val)); });
  }
  document.addEventListener('change', function(e){
    var t = e.target; if (!t || !t.matches || !t.matches('input[type=radio], select')) return;
    if (/^(walnut|white)$/i.test(t.value)) syncFinish(t.value);
  });
  function boot(){
    document.querySelectorAll('[data-tw-map]').forEach(initMap);
    document.querySelectorAll('[data-tw-compare]').forEach(initCmp);
    var w = document.querySelector('input[type=radio][value="White"]:checked'); if (w) syncFinish('White');
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', boot);
})();
